// extracted by mini-css-extract-plugin
export var content = "_bn-3";
export var list = "_bn-4";
export var settingsContent = "_bn-7";
export var settingsPanel = "_bn-8";
export var state = "_bn-6";
export var triggerBadge = "_bn-2";
export var triggerButton = "_bn-1";
export var triggerShell = "_bn-0";
export var unreadDot = "_bn-5";